import axios, { AxiosResponse } from 'axios'
import { fetchJwt } from '.'
import { STRAPI_BASE_URL } from '../constants'
import { UploadFileEntity, UsersPermissionsUser } from '../generated/graphql'

export type StrapiLoginPayload = {
  jwt: string
  user: UsersPermissionsUser
}

const twilioToken = async (): Promise<AxiosResponse<{ token: string }>> => {
  try {
    return await axios.get(STRAPI_BASE_URL + '/twilio-token', {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${fetchJwt()}`
      }
    })
  } catch (error) {
    return Promise.reject(error)
  }
}

const forgotPassword = async (email: string): Promise<AxiosResponse<any>> => {
  try {
    return await axios.post(STRAPI_BASE_URL + '/api/auth/forgot-password', {
      email
    })
  } catch (error) {
    return Promise.reject(error)
  }
}

const resetPassword = async (code: string, password: string, passwordConfirmation: string) => {
  try {
    return await axios.post(STRAPI_BASE_URL + '/api/auth/reset-password', {
      code,
      password,
      passwordConfirmation
    })
  } catch (error) {
    return Promise.reject(error)
  }
}

const changeMyPassword = async (
  password: string,
  passwordNew: string,
  passwordConfirmation: string
) => {
  try {
    return await axios.post(
      STRAPI_BASE_URL + '/change-mypassword',
      {
        password,
        passwordNew,
        passwordConfirmation
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${fetchJwt()}`
        }
      }
    )
  } catch (error) {
    return Promise.reject(error)
  }
}

const login = async (
  identifier: string,
  password: string
): Promise<AxiosResponse<StrapiLoginPayload>> => {
  try {
    return await axios.post(STRAPI_BASE_URL + '/api/auth/local', {
      identifier,
      password,
      type: 'baorider'
    })
  } catch (error) {
    return Promise.reject(error)
  }
}

const register = async (
  username: string,
  email: string,
  password: string
): Promise<AxiosResponse<StrapiLoginPayload>> => {
  try {
    return await axios.post(STRAPI_BASE_URL + '/api/auth/local/register', {
      username,
      email,
      password
    })
  } catch (error) {
    return Promise.reject(error)
  }
}

const upload = async (
  file: File,
  onUploadProgress?: (progressEvent: ProgressEvent, file: File) => void
): Promise<AxiosResponse<UploadFileEntity[]>> => {
  const formData = new FormData()
  formData.append('files', file)
  try {
    return await axios.post(STRAPI_BASE_URL + '/api/upload', formData, {
      onUploadProgress: (event) => onUploadProgress && onUploadProgress(event, file),
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${fetchJwt()}`
      }
    })
  } catch (error) {
    return Promise.reject(error)
  }
}

export default {
  forgotPassword,
  resetPassword,
  login,
  register,
  upload,
  changeMyPassword,
  twilioToken
}
